import Vue from 'vue';

Vue.prototype.$event = new Vue();
